
const API_GATEWAY_URL = 'https://batscan-dev-api-ca8u38bn.ew.gateway.dev/apigateway/'

export const environment = {
    // App Name
    appName: 'batscan-dev',
    // Firebase
    firebaseConfig: {
        apiKey: "AIzaSyBRNIMjwbVAKUGOh9J4Sd-aFU5LY_eRsE8",
        authDomain: "batscan-dev.firebaseapp.com",
        projectId: "batscan-dev",
        storageBucket: "batscan-dev.appspot.com",
        messagingSenderId: "962672061155",
        appId: "1:962672061155:web:f9b88d40cae1b2b08d33d6",
        measurementId: "G-YK0JPJ63JK"
    },
    // Cloud Run
    googleCloudRun: {
        uploadImage: API_GATEWAY_URL + 'uploadFile',
        classify: API_GATEWAY_URL + 'classify',
        modify: API_GATEWAY_URL + 'modify',
        results: API_GATEWAY_URL + 'results',
    },
    // Production
    production: false
};